import type { Errors } from "@/vendor/types";
import type { ResponseError } from "@js-from-routes/client";
import { AxiosError } from "axios";

export function extractError(err: unknown): string | undefined {
  if (!err) return undefined;
  if (isString(err)) return err;
  if (isAxiosError(err) && err.response?.data?.error) return err.response.data.error;
  if (isResponseError(err) && err.body?.error) return err.body.error;
  if (isErrors(err)) return err.error;
  return `${err}`;
}

function isErrors(err: unknown): err is Errors {
  return isPlainObject(err) && "error" in err;
}

function isAxiosError(err: unknown): err is AxiosError<{ error: string }> {
  return err instanceof AxiosError;
}

function isResponseError(err: unknown): err is ResponseError {
  return err instanceof Error && "body" in err;
}
